// api.js

import axios from "axios";
import axiosInstance from "../axiosInstance";
import config from "../../config";
import omsAxiosInstance from "../omsAxiosInstance";
export const orderService = {
  create: async (productData) => {
    try {
      let response = await omsAxiosInstance.post("/order", productData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (client_id, searchValue, query, type, signal) => {
    try {
      let api_query = `/order?`;

      if (client_id) {
        api_query += `&client_id=${client_id}`;
      }

      if (searchValue) {
        api_query += `&order_id[$search]=${encodeURIComponent(searchValue)}`;
      }

      if (query.length) {
        api_query += `&${query}`;
      }
      if (!api_query.includes("$sort")) api_query += `&$sort[createdAt]=-1`;
      if (type === "S2O") {
        api_query += `&type=M2C`;
      } else {
        api_query += `&type=M2O`;
      }
      if (!api_query.includes("sub_type")) {
        api_query += `&sub_type[$in][]=B2B&sub_type[$in][]=B2C`;
      }
      const response = await axiosInstance.get(api_query, signal);
      return response.data;
    } catch (error) {
      console.error("Error fetching orders:", error);
      throw error;
    }
  },
  fetchOrderCount: async (client_id) => {
    try {
      let api = `/order?client_id=${client_id}&$skip=0&$limit=0`;

      let response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async (id, query = "") => {
    try {
      let response = await axiosInstance.get(
        `/order/${id}?$populate=client_id&${query}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (data, id) => {
    try {
      let response = await axiosInstance.patch(`/order/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  trackOrder: async (orderId) => {
    try {
      const response = await axiosInstance.get(`/track-order/${orderId}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Error fetching tracking details: Page not found");
        return { error: "Tracking details not found" };
      } else {
        console.error("Error fetching tracking details:", error);
        return { error: "An unexpected error occurred" };
      }
    }
  },

  fetchOrderTrail: async (orderId) => {
    try {
      const response = await axiosInstance.get(
        `/order-trail-custom/${orderId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchOrderTrailWithoutAuth: async (orderId) => {
    try {
      const response = await axios.get(
        `${config.baseURL}/order-trail-custom/${orderId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchOrderTrailForTracking: async (orderId) => {
    try {
      const response = await axios.get(
        `${config.baseURL}/order-trail-tracking/${orderId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  exportOrders: async (clientId, query) => {
    try {
      let api_query = `/export-orders?`;

      if (clientId) {
        api_query += `&client_id=${clientId}`;
      }
      if (query.length) {
        api_query += `&${query}`;
      }
      // The sheet prints the order date + time; send the browser timezone so it
      // reads the same as the order list on screen instead of the server's zone.
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz) {
        api_query += `&tz=${encodeURIComponent(tz)}`;
      }
      let response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  cancel: async (obj) => {
    try {
      let response = await axiosInstance.post("/cancel-order", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchOrderId: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-orderid?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchPoOfOrders: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-po-of-orders?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCustomerName: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-customer-name?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchCustomerState: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-customer-state?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchShipmentId: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-shipmentid?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchOrderDate: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-order-date?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchStats: async (obj, signal) => {
    try {
      let response = await axiosInstance.post("/stats", obj, { signal });
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  fetchTrackingNumber: async (
    searchKey,
    client_id,
    limit = 15,
    skip = 0,
    signal,
  ) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(
        `/fetch-tracking-number?${query}`,
        { signal },
      );
      console.log(response);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchService: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(
        `/fetch-shipment-service?${query}`,
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchOrderSource: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-order-source?${query}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchOrderTags: async (searchKey, client_id, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}`;
      if (client_id) {
        query += `&client_id=${client_id}`;
      }
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }

      let response = await axiosInstance.get(`/fetch-order-tags?${query}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchRLOMSOrders: async () => {
    try {
      const response = await omsAxiosInstance.get("/order");
      return response.data;
    } catch (error) {
      console.error("Error fetching orders:", error);
      throw error;
    }
  },
  bulkUpload: async (data) => {
    try {
      let response = await omsAxiosInstance.post("/order-bulk-upload", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  uploadConfig: async (data, id) => {
    try {
      let response = await omsAxiosInstance.patch(
        `/bulk-upload-config/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  exposeToClient: async (id, data) => {
    try {
      let response = await axiosInstance.patch(`/expose-order/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
